import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchGetInfrastructure } from '../repositories/infrastructure-caching/v1/get-infrastructure';
export function getMapInfrastructure(_x, _x2, _x3) {
  return _getMapInfrastructure.apply(this, arguments);
}
function _getMapInfrastructure() {
  _getMapInfrastructure = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(httpApi, bbox, logger) {
    var _bbox, _bbox$, leftBottomLng, leftBottomLat, _bbox$2, topRightLng, topRightLat, parameters, _yield$fetchGetInfras, response, statusCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _bbox = _slicedToArray(bbox, 2), _bbox$ = _slicedToArray(_bbox[0], 2), leftBottomLng = _bbox$[0], leftBottomLat = _bbox$[1], _bbox$2 = _slicedToArray(_bbox[1], 2), topRightLng = _bbox$2[0], topRightLat = _bbox$2[1];
          parameters = {
            bbox: "".concat(leftBottomLng, ",").concat(leftBottomLat, "~").concat(topRightLng, ",").concat(topRightLat)
          };
          _context.prev = 2;
          _context.next = 5;
          return fetchGetInfrastructure({
            httpApi: httpApi,
            parameters: parameters
          });
        case 5:
          _yield$fetchGetInfras = _context.sent;
          response = _yield$fetchGetInfras.response;
          statusCode = _yield$fetchGetInfras.statusCode;
          if (!(statusCode !== 200 || 'errors' in response)) {
            _context.next = 10;
            break;
          }
          throw response;
        case 10:
          return _context.abrupt("return", response);
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](2);
          if (logger) {
            logger.error(_context.t0, {
              message: 'error in getMapInfrastructure'
            });
          }
          throw _context.t0;
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 13]]);
  }));
  return _getMapInfrastructure.apply(this, arguments);
}